// extracted by mini-css-extract-plugin
module.exports = {"boxesContainer":"HomepageBody_boxesContainer__1QKxH","homeText":"HomepageBody_homeText__10OSD"};